// extracted by mini-css-extract-plugin
export default {"burger-icon":"Burger_burger-icon__GxT60"};